export default __webpack_public_path__ + "static/media/banner_8.4c5ddfb3.jpg";